module.exports = __webpack_public_path__ + "img/logo-bancolombia.e5900ad6.png";